import { render, staticRenderFns } from "./dangJianShe.vue?vue&type=template&id=d70b888e&scoped=true"
import script from "./dangJianShe.vue?vue&type=script&lang=js"
export * from "./dangJianShe.vue?vue&type=script&lang=js"
import style0 from "./dangJianShe.vue?vue&type=style&index=0&id=d70b888e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70b888e",
  null
  
)

export default component.exports